import React from 'react';
import { goToLoginPage } from '../services/cognito/cognito';
import cryingCirclyImageSrc from '../img/crying_circly.svg';

import './LoginErrorPage.scss';

const LoginErrorPage = () => {
  return (
    <div className="login-error-page">
      <img src={cryingCirclyImageSrc} alt="crying circly" className="m-b-2" />
      <h2 className="m-b-2">An error happened while logging you in.</h2>
      <button className="btn btn-primary" onClick={() => goToLoginPage(window.location.pathname)}>
        Try again
      </button>
    </div>
  );
};

export default LoginErrorPage;
